<template>
  <div>
    <v-container grid-list-lg class="ma-0 pa-0">
    <v-layout
      row
      wrap
      grid-list-xl
    >
      <v-flex
        md6
        xs12
      >
        <v-card
          row
          class=""
        >
          <v-card-title
            primary-title
            class="grey lighten-4"
          >
            <h3 class="title mb-0">Mein Betrieb:  {{ this.$store.getters.authBetrieb.name }}</h3>
            <!-- <v-spacer></v-spacer>
            <v-btn @click="CheckBetrieb()" icon class="my-0" flat> 
              <v-icon color="grey darken-2">refresh</v-icon>
            </v-btn> -->
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <p
              class="text-xs-center mt-4"
              v-if="betriebcheckloading == true"
            >
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </p>
            <span v-if="betriebcheckloading !== true">
               <div v-if="BetriebVorhanden">
               
              <!-- <span class="subheading">Verknüpft mit:
                  {{ this.$store.getters.authBetrieb.name }}
                </span> -->
              <v-layout row wrap>
                <v-flex xs12 >
                

                  <v-btn
                    color="accent"
                    class="mt-1"
                    large
                    block
                    to="/meinbetrieb"
                  >Meinen Betrieb verwalten</v-btn>
                   <v-btn
                    color="accent"
                    class="mt-3 mb-4"
                    large
                    block
                    :to="{name: 'showCompany', params: {id: this.$store.getters.authBetrieb.slug}}"
                  >Profil ansehen</v-btn>
                    <a
                    :href="BetriebLink"
                    target="_blank"
                    class="subheading"
                    style="line-break: anywhere;"
                  >{{ BetriebLink.substring(8) }}</a>
                </v-flex>
                
                <!-- <v-flex xs12 sm5  class="text-xs-center text-sm-right">
                  <v-card flat v-if="qrcode"
                    >
                    <span v-html="qrcode"></span>
                     
                  </v-card>
                  <div class="text-xs-center" v-else>
                    <v-progress-circular
                      indeterminate
                      color="accent"
                    ></v-progress-circular>

                  </div>
                </v-flex> -->
              </v-layout>

              </div>
              <div
                v-else
                class="subheading"
              >Leider noch kein Betrieb verknüpft.
                <br>Wenn Sie einen Betrieb verwalten möchten, teilen Sie uns bitte den Namen, die Innung und den gewünschten Weg der Verifizierung mit.
                <v-card-actions>
                  <v-btn
                    v-if="!show"
                    @click="show = !show; scrollhochmobile()"
                    color="accent"
                  >Betrieb verknüpfen
                    <v-icon right>link</v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    icon
                    @click="show = !show; scrollhochmobile()"
                  >
                    <v-icon>{{ show ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
                  </v-btn>
                </v-card-actions>
                <v-slide-y-transition>
                  <v-card-text
                    v-show="show"
                    class="mt-0 pt-0"
                  >
                    <v-form
                      ref="form"
                      v-model="valid"
                      lazy-validation
                    >
                      <v-text-field
                        label="Name Ihres Betriebs"
                        v-model="BetriebName"
                        :rules="BetriebNameRules"
                        name="BetriebName"
                      ></v-text-field>
                      <v-text-field
                        label="Innung, bitte mit Stadt angeben"
                        v-model="BetriebInnung"
                        :rules="BetriebInnungRules"
                        name="BetriebInnung"
                      ></v-text-field>
                      <v-select
                        :items="veriitems"
                        v-model="BetriebVerifikation"
                        label="Bevorzugte Art der Verifizierung"
                        :rules="[v => !!v || 'Bitte auswählen']"
                        name="BetriebVerifikation"
                      ></v-select>
                      <v-btn
                        @click="Betrieblinkpost()"
                        color="accent"
                        :loading="loading"
                        :disabled="block"
                        id="checkheadline"
                      >Anfrage senden</v-btn>
                      <v-btn
                        @click="CheckBetrieb()"
                        color="accent"
                        v-if="block"
                      >Status überprüfen</v-btn>
                    </v-form>
                  </v-card-text>
                </v-slide-y-transition>
              </div>
            </span>
          </v-card-text>
        </v-card>

           <v-card
          row
          class="mt-3"
           v-if="BetriebVorhanden"
        >
          <v-card-title
            primary-title
            class="grey lighten-4"
          >
            <h3 class="title mb-0">Verfügbarkeit</h3>
            <!-- <v-btn @click="CheckBetrieb()" icon class="my-0" flat> 
              <v-icon>refresh</v-icon>
            </v-btn> -->
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>

            <div class="subheading">
              <div
                v-if="VerfuegbarBis"
                class="mb-2"
              >
                Verfügbar markiert bis: <strong>{{ VerfuegbarBis }} </strong>
                <v-icon
                  right
                  color="green"
                >check_circle</v-icon>
              </div>
              <v-btn
                large
                color="green"
                :loading="verfuegbarloading"
                @click="Verfuegbarmarkieren()"
                dark
              >{{ VerfuegbarText }} <v-icon right v-if="VerfuegbarBis">refresh</v-icon>
              </v-btn>

              <v-btn
                large
                v-if="VerfuegbarBis"
                @click="Verfuegbarentfernen()"
                
              >Zurücknehmen <v-icon right v-if="VerfuegbarBis">close</v-icon>
              </v-btn>

              <p class="headline mt-4">Erklärung</p>
              <p>Wenn Sie Ihren Betrieb als verfügbar markieren, signalisieren Sie Kunden, dass Sie <strong>aktuell Kapazitäten für neue Aufträge</strong> haben.</p>
              <p>
                Dies fließt dann in die <strong>Sortierung der Suchergebnisse</strong> sowie die Darstellung Ihres Betriebs ein.
              </p>

              <p>Die Angabe ist <strong>rein freiwillig, an keine Verpflichtungen gekoppelt und läuft nach 30 Tagen automatisch ab</strong>. Wir behalten uns aber das Recht vor, die Funktion bei Missbrauch für bestimmte Betriebe zu deaktivieren. </p>

            </div>

          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex
        md6
        xs12
        xv-if="BetriebVorhanden"
      >
           <v-card
          row
          hover
          class=""
          href="https://www.lokaleshandwerk.de/flyer/LokalesHandwerk_Flyer_Web.pdf"
          target="_blank"
        >
          <v-card-title
            primary-title
            class="grey lighten-4"
          >
            <h3 class="title mb-0">Unser Angebot an Innungsbetriebe</h3>
            <!-- <v-btn @click="CheckBetrieb()" icon class="my-0" flat> 
              <v-icon>refresh</v-icon>
            </v-btn> -->
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-img
              src="././img/lhflyerpreviewtab.webp" 
            />
        </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    </v-container>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  data () {
    return {
      betriebcheckloading: true,
      BetriebName: '',
      BetriebInnung: '',
      BetriebVerifikation: '',
      show: false,
      busy: false,
      loading: false,
      verfuegbarloading: false,
      qrcode: '',
      qrloading: false,
      block: false,
      veriitems: ['Telefonisch', 'Per E-Mail'],

      valid: false,

      BetriebNameRules: [
        (v) => !!v || 'Bitte den Namen Ihres Betriebs angeben'
      ],
      BetriebInnungRules: [
        (v) => !!v || 'Bitte den Namen Ihres Betriebs angeben'
      ]
    }
  },
  computed: {
    BetriebVorhanden: function () {
      if (this.$store.getters.authBetrieb) {
        if (this.$store.getters.authBetrieb.name) return true
      }
    },
    BetriebLink: function () {
      return (
        'https://www.lokaleshandwerk.de/betrieb/' +
        this.$store.getters.authBetrieb.slug
      )
    },
    VerfuegbarText: function () {
      if (this.VerfuegbarBis) {
        if (this.$vuetify.breakpoint.name === 'xs') {
          return 'verlängern'
        } else {
          return 'Um 30 Tage verlängern'
        }
      } else {
        if (this.$vuetify.breakpoint.name === 'xs') {
          return 'verfügbar markieren'
        } else {
          return 'Für 30 Tage verfügbar markieren'
        }
      }
    },
    VerfuegbarBis: function () {
      if (this.$store.getters.authBetrieb) {
        if (this.$store.getters.authBetrieb.verfuegbar) {
          var myDate = new Date(
            new Date(this.$store.getters.authBetrieb.verfuegbar).getTime() +
              30 * 24 * 60 * 60 * 1000
          )
          myDate = myDate.toLocaleDateString()
          return myDate
        }
      }
    }
  },
  mounted: function () {
    this.betriebcheckloading = false
    this.CheckBetrieb()
    //this.getQR()
  },
  methods: {
    Betrieblinkpost () {
      if (this.$refs.form.validate()) {
        this.loading = true

        const betriebsdaten = {
          betriebsname: this.BetriebName,
          innung: this.BetriebInnung,
          verifikation: this.BetriebVerifikation
        }

        axios
          .post('/api/v1/ticketbetrieblink', betriebsdaten)
          .then((resp) => {
            // console.log(resp)

            this.$store.dispatch('responseMessage', {
              type: 'success',
              modal: 'true',
              title: 'Anfrage erfolgreich gesendet! ',
              text: 'Wir werden uns baldmöglichst bei Ihnen melden!.'
            })

            this.block = true
          })
          .catch((resp) => {
            // console.log('error: ')
            //   console.log(resp);
          })

        this.loading = false
      }
    },
    Verfuegbarmarkieren () {
      this.verfuegbarloading = true

      axios
        .post('/api/v1/verfuegbarmarkieren')
        .then((resp) => {
          // console.log(resp)

          this.$store.dispatch('responseMessage', {
            type: 'success',
            xmodal: 'false',
            title: 'Als verfügbar markiert!',
            text:
              'Vielen Dank! Ihr Betrieb wird jetzt für 30 Tage in Suchen hervorgehoben.'
          })
        })
        .catch((resp) => {
          // console.log('error: ')
          console.log(resp)
        })
        .finally((response) => {
          console.log('finally yolo')
          this.$store.dispatch('fetchUser')
          this.verfuegbarloading = false
        })
    },
    Verfuegbarentfernen () {
      this.verfuegbarloading = true

      axios
        .post('/api/v1/verfuegbarentfernen')
        .then((resp) => {
          // console.log(resp)

          this.$store.dispatch('responseMessage', {
            type: 'success',
            xmodal: 'false',
            title: 'Zurückgenommen',
            text:
              'Ihr Betrieb ist jetzt nichtmehr als verfügbar markiert.'
          })
        })
        .catch((resp) => {
          // console.log('error: ')
          console.log(resp)
        })
        .finally((response) => {
          console.log('finally yolo')
          this.$store.dispatch('fetchUser')
          this.verfuegbarloading = false
        })
    },
    // getQR () {
    //   this.qrloading = true

    //   axios
    //     .get('/api/v1/qrdebug')
    //     .then((resp) => {
    //       // console.log(resp)
    //       this.qrcode = resp.data
    //     })
    //     .catch((resp) => {
    //       // console.log('error: ')
    //       console.log(resp)
    //     })
    //     .finally((response) => {
    //       this.qrloading = false
    //     })
    // },
    scrollhochmobile: function () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        console.log('scroll versuch')
        this.$vuetify.goTo('#checkheadline')
      }
    },
    async CheckBetrieb () {
      console.log('betriebscheck...')
      this.busy = true
      // eslint-disable-next-line no-unused-vars
      const data = await this.$store.dispatch('fetchUser')
      this.busy = false
    }
  }
}
</script>

<style>
</style>